/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedCallDealerCta_user$ref = any;
export type PdpSharedCallDealerCta_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly authMetadata: {
        readonly emailOnly: boolean | null;
    } | null;
    readonly " $refType": PdpSharedCallDealerCta_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedCallDealerCta_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authMetadata",
      "storageKey": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "emailOnly",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '4aa135194923a76a1ac478da4f9e1964';
export default node;
